'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

(0, _jquery2.default)(document).on('click', '.js-accordion-head', function (e) {
	e.preventDefault();
	var $that = (0, _jquery2.default)(this);

	$that.parent().toggleClass('is-active-accordion').find('.accordion__body').slideToggle();

	$that.parent().siblings().removeClass('is-active-accordion').find('.accordion__body').slideUp();
});

if ((0, _jquery2.default)('.js-accordion').length) {
	setTimeout(function () {
		(0, _jquery2.default)('.js-accordion > .accordion__section:first-child > .js-accordion-head').trigger('click');
	}, 500);
}